import { useEffect } from 'react'
import i18n from '@/i18n'
import { useSettingsStore } from '@/stores/settingsStore'

export function useLanguage() {
  const language = useSettingsStore((s) => s.language)

  useEffect(() => {
    if (i18n.language !== language) i18n.changeLanguage(language)
    document.documentElement.lang = language
  }, [language])
}
